import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion as HeroAccordion } from '@heroui/react';
export const Accordion = (props) => {
    return _jsx(HeroAccordion, { ...props });
};
export { AccordionItem } from '@heroui/react';
export default Accordion;
//# sourceMappingURL=Accordion.js.map